module.exports = __webpack_public_path__ + "img/Stripe_Berst-Powered-by-Stripe-Logo.wine.6969529e.png";